import axios from "axios";
import Swal from "sweetalert2";
import admin from "firebase/compat/app";
import "firebase/compat/firestore";

export async function downloadFile(name, blob) {
  const fileDownloadUrl = URL.createObjectURL(blob);
  this.dofileDownload.click();
  URL.revokeObjectURL(fileDownloadUrl);
}

var saveData = (function () {
  var a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  return function (data, fileName) {
    var url = window.URL.createObjectURL(data);
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
  };
})();

export function reportAnalysisStatus(time, callback) {
  let host = "https://gpu.sportsbox.ai:40030";
  if (window.location.href.includes("localhost")) {
    host = "http://gpu.sportsbox.ai:40030";
  }
  return new Promise(async (resolve, reject) => {
    await new Promise((resolveInner) => setTimeout(resolveInner, 1000));
    let resData = {};
    do {
      await axios(`${host}/web_inference/${time}`, {
        method: "GET",
      }).then((res) => {
        resData = res.data || {};
        console.log(resData);
        resData.statusText = `${resData.stage}: ${parseInt(
          (parseFloat(resData.current_num_frame) /
            parseFloat(resData.total_num_frame)) *
            100
        )}% `;
        callback(resData);
      });
    } while (resData.stage);
    resolve("done");
  });
}
